import { Component, Input, OnInit } from '@angular/core'

@Component({
  selector: 'app-container-middle',
  templateUrl: './container-middle.component.html',
  styleUrls: ['./container-middle.component.sass'],
})
export class ContainerMiddleComponent implements OnInit {
  constructor() {}

  @Input() public height = 50
  @Input() isEditing = false

  ngOnInit() {}
}
